'use client'
import React, { useEffect } from 'react'
import SimpleComponent from '@/components/widgets/SimpleComponent'
import Footer from '@/components/widgets/footer/Footer'
import NewLoveAffir from './home-page-widgets/NewLoveAffir'

const HomePageNew = () => {
  useEffect(() => {
    const isExistsItem = window.localStorage.getItem('initialPopUp')
    if (!isExistsItem) {
      window.localStorage.setItem('initialPopUp', 'true')
    }
  }, [])

  return (
    <SimpleComponent>
      <NewLoveAffir />
      <Footer />
    </SimpleComponent>
  )
}

export default HomePageNew
